import { useContext } from "react";
import { StockMovementContext } from "../contexts/stockMovementContext";

const useStockMovementContext = () => useContext(StockMovementContext);

export default useStockMovementContext;
